import { Grid, Typography } from "@mui/material";
import CustomField from "../../forms/CustomField";

interface IProps {
	id: string;
	text: string;
	handleChange: any;
	label?: string;
}

export default function TextItem({ id, text, handleChange, label }: IProps) {
	return (
		<Grid item md={5} xs={12} style={{ margin: "10px" }}>
			{/* CustomField fuerza label="" (los formularios públicos usan
			    placeholder), así que el nombre del campo va aquí arriba */}
			<Typography variant="subtitle2" fontWeight={700}>
				{label || id.toUpperCase()}
			</Typography>
			<CustomField
				name={id}
				value={text}
				multiline
				onChange={(e: any) => handleChange(e.target.value)}
			/>
		</Grid>
	);
}
